import { useEffect, useState } from 'react';
import { Empty, Modal, Row, Col, List, Popover, Tag, Typography, Divider, Select } from 'antd';
import moment from 'moment';
const { Title } = Typography;
const { Option, OptGroup } = Select;

const ModalList = ({
  centerData,
  isModalVisible,
  setisModalVisible,
  city
}) => {
  const [ageLimit, setAgeLimit] = useState(45);

  const handleChange = (value) => { 
    setAgeLimit(value);
  } 

  const NoDataMsg = (age) =>{
    return (<div>
      <p>{`At this second, there are no slots available for ${age}+ vaccine, but this could change depending on the centers themselves. `}</p> 
      <p><a onClick={()=>setisModalVisible(false)}>Sign up on the form</a> to get notified when this happens!</p>
    </div>)
  }

  const dataArr18 = centerData?.centers?.filter(center => { 
    return center.sessions.some(s => (s.available_capacity > 0 && s.min_age_limit === 18))
  })
  const dataArr45 = centerData?.centers?.filter(center => { 
    return center.sessions.some(s => (s.available_capacity > 0 && s.min_age_limit === 45))
  })

  return (
    <Modal style={{ top: 20 }} className={'list-modal'} footer={null} visible={isModalVisible} onCancel={() => setisModalVisible(false)}>

      <Row>
        <Col lg={24}>

          {/* <div className={'p-2 flex justify-end flex-col mb-2'}>

            <Divider orientation="right">Guides</Divider>
            <div className={'flex justify-end'}>

              <Tag color="green">Availabile</Tag> 
              <Tag color="red">Unavailable</Tag>
            </div>
          </div> */}
          <div className={'my-8'} />
          <List
            header={
              <div className={'flex justify-between items-center'}>

                <Title level={4} style={{ margin: 0 }}>{`Centers in ${city}`} </Title>
                <div className={'flex items-center'}>
                <p className={'mr-2 m-0'}>Age</p>
                <Select defaultValue="45" style={{ width: 75 }} onChange={handleChange}>
                  <Option value="45">45+</Option>
                  <Option value="18">18+</Option>
                </Select>
                </div>

              </div>}
            footer={null}
            bordered>

            {ageLimit == 18 && <>
              {dataArr18?.map((item, index) => {
                return (
                  <List.Item>

                    <div className={'flex flex-col'}>
                      <Title level={5} style={{ margin: 0 }}>{item.name}  </Title>
                      <p style={{ fontSize: '10px' }}>{`Pincode: ${item.pincode}`}</p>
                    </div>
                    <div style={{ maxWidth: '450px' }}>

                      {item.sessions.map((item, index) => {
                        return (<Popover content={(
                          <div>
                            <p>{`Available Vaccine: ${item.available_capacity}`}</p>
                            <p>{`Min Age Limit: ${item.min_age_limit}`}</p>
                            <p>{`Slots Available: ${item.slots.length}`}</p>
                            <p>{`Vaccine: ${item?.vaccine ? item.vaccine : ''}`}</p>
                          </div>
                        )} title="Details">
                           {item.available_capacity != 0 &&
                          // <Tag color={"green"}>{`${moment(item.date, 'DD-MM-YYYY').format('DD MMM')} (${item?.slots?.length} slots) ${item?.vaccine ? `| ${item.vaccine}`: ''}`}</Tag>
                          <Tag color={"green"}>{`${moment(item.date, 'DD-MM-YYYY').format('DD MMM')} (${item?.slots?.length} slots)`}</Tag>
                          }
                        </Popover>
                        )
                      })}
                    </div>


                  </List.Item>
                )
              })}
              {dataArr18?.length == 0 && <div className={'flex w-full justify-center my-10'}><Empty description={NoDataMsg(18)} /></div>}
              </>}

            {ageLimit == 45 && <>
              {dataArr45?.map((item, index) => {
                return (
                  <List.Item>

                    <div className={'flex flex-col'}>
                      <Title level={5} style={{ margin: 0 }}>{item.name}  </Title>
                      <p style={{ fontSize: '10px' }}>{`Pincode: ${item.pincode}`}</p>
                    </div>
                    <div style={{ maxWidth: '450px' }}>

                      {item.sessions.map((item, index) => {
                        return (<Popover content={(
                          <div>
                            <p>{`Available Vaccine: ${item.available_capacity}`}</p>
                            <p>{`Min Age Limit: ${item.min_age_limit}`}</p>
                            <p>{`Slots Available: ${item.slots.length}`}</p>
                            <p>{`Vaccine: ${item?.vaccine ? item.vaccine : ''}`}</p>
                          </div>
                        )} title="Details">
                          {item.available_capacity != 0 &&
                          <Tag color={"green"}>{`${moment(item.date, 'DD-MM-YYYY').format('DD MMM')} (${item?.slots?.length} slots)`}</Tag>
                          }
                        </Popover>
                        )
                      })}
                    </div>


                  </List.Item>
                )
              })}
              {dataArr45?.length == 0 && <div className={'flex w-full justify-center my-10'}><Empty description={NoDataMsg(45)} /></div>}
              </>}

          </List>
        </Col>

      </Row>
    </Modal>
  )
}


export default ModalList